// extracted by mini-css-extract-plugin
export default {"scannerContainer":"QrScannerComponent_scannerContainer__lAnog","scannerVideo":"QrScannerComponent_scannerVideo__UOktY","overlay":"QrScannerComponent_overlay__EHmZw"};